<template>
	<div class="profile-sync">
		<div class="label">Connecting your account only pulls your most recent month of solve data. You can press this button to go back and fetch all of your solves. This may take some time if you have a lot of solves, be patient!</div>
		<div class="action">
			<button class="btn waves-effect waves-light blue lighten-2" :class="{disabled: goingBack}" @click="goBack"><i class="fas fa-sync-alt" :class="{'fa-spin': goingBack}"></i> {{ goingBack ? "Searching..." : "Find Old Solves" }}</button>
			<div class="success" v-if="solvesAdded !== null"><i class="fas fa-check-circle"></i>{{ solvesAdded }} solves added</div>
		</div>
		<div class="label">If you notice your average solve times seeming out of sync, you can press this button to recalculate them all. You should not have to do this often.</div>
		<div class="action">
			<button class="btn waves-effect waves-light blue lighten-2" :class="{disabled: recalcing}" @click="recalc"><i class="fas fa-sync-alt" :class="{'fa-spin': recalcing}"></i> {{ recalcing ? "Calculating..." : "Recalculate Averages" }}</button>
			<div class="success" v-if="solvesUpdated !== null"><i class="fas fa-check-circle"></i>{{ solvesUpdated }} solves adjusted</div>
		</div>
		<div class="label">If you would like to disconnect your New York Times Account from XW Stats and delete your solve data you can press this button.</div>
		<div class="action">
			<a class="waves-effect waves-light btn red lighten-2" href="/profile/disconnect" @click="confirmLink('This will unlink your NYT account and remove all of your solve data. Proceed with the disconnect?', $event)"><i class="fas fa-user-minus"></i> Disconnect Account</a>
		</div>
	</div>
</template>
<script>
const axios = require('axios');
const cookies = require('browser-cookies');

export default {
	data: function() {
		return {
			goingBack: false,
			solvesAdded: null,
			recalcing: false,
			solvesUpdated: null,
		};
	},
	methods: {
		goBack: function() {
			this.goingBack = true;
			this.solvesAdded = null;
			this.makeGoBackRequest(0).then(solves => {
				this.solvesAdded = solves;
			}).finally(() => {this.goingBack = false;})
		},
		makeGoBackRequest: function(solvesSoFar) {
			return axios({
				method: 'post',
				url: '/api/findSolves',
				headers: {
					'X-CSRFToken': cookies.get('csrftoken'),
				},
			}).then(resp => {
				solvesSoFar += resp.data.solvesAdded;
				if (resp.data.more) {
					return this.makeGoBackRequest(solvesSoFar);
				} else {
					return solvesSoFar;
				}
			});
		},
		recalc: function() {
			this.recalcing = true;
			this.solvesUpdated = null;
			axios({
				method: 'post',
				url: '/api/recalc',
				headers: {
					'X-CSRFToken': cookies.get('csrftoken'),
				},
			}).then(resp => {
				this.solvesUpdated = resp.data.solvesUpdated;
			}).finally(() => {this.recalcing = false});
		},
		confirmLink: function(msg, e) {
			if (!window.confirm(msg)) {
				e.preventDefault();
			}
		},
	},
};
</script>
<style lang="scss">
.profile-sync {
	.action {
		width: 100%;
		display: flex;
		align-items: center;
    justify-content: flex-start;
		margin-bottom: 1.5rem;
		&:last-child {
			margin-bottom: 0;
		}
		.success {
			margin-left: 1rem;
			i {
				margin-right: 0.5rem;
			}
		}
	}
	.label {
		width: 100%;
		font-size: 0.875rem;
		display: block;
		margin-bottom: 0.5rem;
	}
}
</style>
